import QueryBuildings from "graphql/queries/QueryBuildings";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

const FetchBuilding = {
	
	fetchAll: ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'buildings', QueryBuildings, {
			resultPath: [ 'buildings' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}

export default FetchBuilding
